export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-shuffle-69b2c57552396fce7045072a4e13dfb6.svg";